import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';



function Syllabus() {

  const pageTitleText = "JEE 2027 Syllabus";


  return (
    <>

      <SubjectPage
        name={pageTitleText}
        link="syllabus"
      />

    </>
  );
}

export default Syllabus;